import axios from 'axios';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import * as S from './LoginScreen.css';

type FormData = {
  username: string;
  password: string;
  newpassword: string;
  newpassword2: string;
};

export const PasswordExpiredForm = () => {
  const [_searchParams, setSearchParams] = useSearchParams();

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm<FormData>();

  const { t } = useTranslation(['login', 'validation', 'user']);

  const onSubmit: SubmitHandler<FormData> = async (data) => {
    const body = new URLSearchParams(Object.entries(data)).toString();
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      credentials: 'same-origin',
    };
    const response = await axios.post('/backend/login.do', body, config);
    const responseURL = new URL(response.headers.location);
    const responseParams = Array.from(responseURL.searchParams.keys());

    if (responseParams[0] === 'password_changed') {
      setSearchParams({ alert: 'password_changed' });
    }
  };

  return (
    <S.Form onSubmit={handleSubmit(onSubmit)}>
      <S.FieldGroup>
        <div>
          <S.Input
            {...register('username', {
              required: t('required', { ns: 'validation' }),
            })}
            name='username'
            variant='outlined'
            size='small'
            label={t('userPlaceholder', { ns: 'login' })}
          />
          {errors.username && <S.Error>{errors?.username?.message}</S.Error>}
        </div>
      </S.FieldGroup>
      <S.FieldGroup>
        <div>
          <S.Input
            {...register('password', {
              required: t('required', { ns: 'validation' }),
            })}
            type='password'
            name='password'
            variant='outlined'
            size='small'
            label={t('passwordPlaceholder', { ns: 'login' })}
          />
          {errors.password && <S.Error>{errors?.password?.message}</S.Error>}
        </div>
      </S.FieldGroup>
      <S.FieldGroup>
        <div>
          <S.Input
            {...register('newpassword', {
              required: t('required', { ns: 'validation' }),
              minLength: {
                value: 3,
                message: t('minLength', {
                  ns: 'validation',
                  replace: { '0': 3 },
                }),
              },
              maxLength: {
                value: 64,
                message: t('maxLength', {
                  ns: 'validation',
                  replace: { '0': 64 },
                }),
              },
            })}
            type='password'
            name='newpassword'
            variant='outlined'
            size='small'
            label={t('newPasswordPlaceholder', { ns: 'login' })}
          />
          {errors.newpassword && (
            <S.Error>{errors?.newpassword?.message}</S.Error>
          )}
        </div>
      </S.FieldGroup>
      <S.FieldGroup>
        <div>
          <S.Input
            {...register('newpassword2', {
              required: t('required', { ns: 'validation' }),
              validate: (value) =>
                value === getValues('newpassword') ||
                t('passwordsDontMatch', { ns: 'user' }),
              minLength: {
                value: 3,
                message: t('minLength', {
                  ns: 'validation',
                  replace: { '0': 3 },
                }),
              },
              maxLength: {
                value: 64,
                message: t('maxLength', {
                  ns: 'validation',
                  replace: { '0': 64 },
                }),
              },
            })}
            type='password'
            name='newpassword2'
            variant='outlined'
            size='small'
            label={t('newPasswordConfirmationPlaceholder', {
              ns: 'login',
            })}
          />
          {errors.newpassword2 && (
            <S.Error>{errors?.newpassword2?.message}</S.Error>
          )}
        </div>
      </S.FieldGroup>
      <S.LoginButton type='submit'>
        {t('signin', { ns: 'login' })}
      </S.LoginButton>
    </S.Form>
  );
};
